import "bootstrap";
import { IpfModule } from ".";
import { container } from "./ioc/container.config";
import { TYPES } from "./ioc/types";
import { PageService } from "./services";

// expose the IPF module and reference as IPF
export const IPF = container.get<IpfModule>(TYPES.IpfModule);

// register the ready event of the page service
document.addEventListener("DOMContentLoaded", () => {
    const pageService = container.get<PageService>(TYPES.PageService);
    pageService.ready();
});